import { useIntl } from 'react-intl'
import theme from 'theme_'

import { homeDeviceInformationMessages as messages } from '../../messages'
import DeviceInformationCard from '../../components/DeviceInformationCard'
import { DeviceStatusColorProps } from '../types'

function GreyStatus({ statusString }: DeviceStatusColorProps) {
  const { formatMessage } = useIntl()

  return (
    <DeviceInformationCard
      title={formatMessage(messages.deviceConnectionStatusLabel)}
      value={
        statusString || formatMessage(messages.deviceStatusCardDisconnected)
      }
      color={theme.colors.moreGrey}
      bgColor={theme.colors.white}
      order={1}
    />
  )
}

export default GreyStatus
